import { MetricTableHeader } from '~/types/model/analytics/analytics-chart.model'
import type { IPagination } from '~/types/pagination.type'
import type { ValueOf } from '~/types/value-of'

export const defiCategoryType = {
  DEXES: 'Dexes',
  RWA: 'RWA',
  LIQUID_STAKING: 'Liquid Staking',
  LENDING: 'Lending',
  BRIDGE: 'Bridge',
  CDP: 'CDP',
  DERIVATIVES: 'Derivatives',
  YIELD: 'Yield',
  PAYMENTS: 'Payments',
  LAUNCHPAD: 'Launchpad',
  NFT_MARKETPLACE: 'NFT Marketplace'
} as const
export type defiCategoryType = ValueOf<typeof defiCategoryType>

export const sortDirectionType = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const
export type sortDirectionType = ValueOf<typeof sortDirectionType>

export interface IDefiRequestParam extends IPagination {
  search: string
  category: string
  field: string
  direction: sortDirectionType
}

export type metricTableDataType = Record<string, string>
